const FacebookIcon = ({ height = 28, width = 28 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 28 28"
      fill="none"
    >
      <g clip-path="url(#clip0_2274_23449)">
        <rect width="28" height="28" rx="6" fill="#1877F2" />
        <path
          d="M28 14.0856C28 6.30637 21.7319 0 14 0C6.26806 0 0 6.30637 0 14.0856C0 21.116 5.11963 26.9434 11.8125 28V18.1572H8.25781V14.0856H11.8125V10.9823C11.8125 7.45214 13.9027 5.50217 17.1006 5.50217C18.6322 5.50217 20.2344 5.77728 20.2344 5.77728V9.24365H18.4691C16.7299 9.24365 16.1875 10.3294 16.1875 11.4434V14.0856H20.0703L19.4496 18.1572H16.1875V28C22.8804 26.9434 28 21.1161 28 14.0856Z"
          fill="#1877F2"
        />
        <path
          d="M19.4496 18.0469L20.0703 14H16.1875V11.3739C16.1875 10.2666 16.7299 9.1875 18.4691 9.1875H20.2344V5.74219C20.2344 5.74219 18.6322 5.46875 17.1005 5.46875C13.9027 5.46875 11.8125 7.40688 11.8125 10.9156V14H8.25781V18.0469H11.8125V28.2564C12.5361 28.3698 13.2675 28.5002 14 28.5C14.7325 28.5002 15.4639 28.2256 16.1875 28.1122V18.0469H19.4496Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2274_23449">
          <rect width="28" height="28" rx="6" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default FacebookIcon
